import { inject, Injectable } from '@angular/core';
import { UrlTree, Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import {
  BehaviorSubject,
  catchError,
  firstValueFrom,
  map,
  Observable,
} from 'rxjs';
import { environment } from 'src/environments/environment';
import { SnackbarService } from './snackbar.service';

@Injectable({
  providedIn: 'root',
})
export class GlobalService {
  url = environment.API_URL;
  url_MOBILEPAY = environment.API_MOBILEPAY;
  private dateBS = new BehaviorSubject<string>(this.Fecha());
  date$ = this.dateBS.asObservable();
  private snack = inject(SnackbarService);
  constructor(private router: Router, private http: HttpClient) {}

  get Token(): string {
    return localStorage.getItem('AccessToken') ?? '';
  }
  get RefreshJWT(): string {
    return localStorage.getItem('RefreshToken') ?? '';
  }

  Header(): HttpHeaders {
    const headers = new HttpHeaders()
      .set('Authorization', `Token ${this.Token}`)
      .set('Content-Type', 'application/json');
    return headers;
  }

  setJWT() {}

  Fecha(): string {
    return new Date().toISOString().slice(0, 10);
  }
  User() {
    const a = localStorage.getItem('user') ?? '';
    sessionStorage.setItem('user', a);
    return JSON.parse(sessionStorage.getItem('user') ?? '');
  }

  cleanJson(jsonString: string): any | '' {
    // console.log(jsonString);
    const endIndex = jsonString.indexOf('ONU CATV');
    const result = jsonString.substring(0, endIndex);
    // console.log(result);
    try {
      return JSON.parse(jsonString);
      //return JSON.stringify(jsonObj, null, 2);
    } catch (error) {
      console.error(error);
      return '';
    }
  }

  changeDate(date: string) {
    const a = new Date(date).toISOString().slice(0, 10);
    this.dateBS.next(a);
  }

  formatearFecha(date: string = '') {
    const fecha = new Date(date);
    const anio = fecha.getFullYear();
    const mes = fecha.getMonth() + 1;
    const dia = fecha.getDate();
    const fechaFormateada = `${anio}-${mes < 10 ? '0' : ''}${mes}-${
      dia < 10 ? '0' : ''
    }${dia}`;
    return fechaFormateada;
  }

  shortDate(date: Date): string {
    return date.toLocaleDateString('sv-SE');
  }
  formatearFechaHora(date: string = '') {
    const fechaOriginal = new Date(date);

    // Obtener día, mes y año
    const dia = fechaOriginal.getDate();
    const mes = fechaOriginal.getMonth() + 1;
    const anio = fechaOriginal.getFullYear();

    // Obtener hora y minutos
    let hora = fechaOriginal.getHours();
    const minutos = fechaOriginal.getMinutes();

    // Determinar AM o PM
    const amOpm = hora >= 12 ? 'PM' : 'AM';

    // Convertir a formato de 12 horas
    hora = hora % 12;
    hora = hora ? hora : 12;

    // Construir la cadena formateada
    const fechaFormateada = `${dia}-${mes}-${anio} ${hora}:${minutos
      .toString()
      .padStart(2, '0')} ${amOpm}`;

    return fechaFormateada;
  }

  formatearUser(obj: boolean, nombre: string | null, nuevo: object) {
    // funcion para formatear la informacion del sessionStorage
    if (obj) {
      const a = { ...this.User(), oficina: { ...nuevo } };
      localStorage.setItem('user', JSON.stringify(a));
    } else {
      const a = { ...this.User(), ...nuevo };
      localStorage.setItem('user', JSON.stringify(a));
    }
  }

  formatearNumero(numero: number) {
    // Dividir el número en partes enteras y decimales
    const partes = numero.toFixed(2).split('.');

    // Agregar comas como separadores de miles en la parte entera
    const parteEnteraFormateada = partes[0].replace(
      /\B(?=(\d{3})+(?!\d))/g,
      '.'
    );

    // Unir la parte entera formateada con las decimales y devolver el resultado
    return parteEnteraFormateada + ',' + partes[1];
  }
  getBanks(type: number): Promise<any> {
    const obs$ = this.http.get<any>(
      `${this.url}/api/gsoft/payments/banks/?type=${type}&remove_pagination=true`
    );
    return firstValueFrom(obs$);
  }
  Permissions(perm: string): boolean {
    let user = this.User();
    if (user.is_superuser) {
      return true;
    }
    if (localStorage.getItem('permissions')) {
      const storage: string[] = JSON.parse(
        localStorage.getItem('permissions') || ''
      );
      return storage.includes(perm);
    }
    return false;
  }
  PermissionsMenu(perm: string): void {
    let user = this.User();
    if (user.is_superuser) {
      this.router.navigate([this.router.url]);
      return;
    }
    const storage: string[] = JSON.parse(
      localStorage.getItem('permissions') || ''
    );
    if (storage.includes(perm)) {
      this.router.navigate([this.router.url]);
      return;
    }
    this.router.navigate(['./home/inicio']);
    return;
  }

  private getFilenameFromResponse(response: any): string {
    const contentDispositionHeader = response.headers.get(
      'content-disposition'
    );
    const matches = contentDispositionHeader
      ? contentDispositionHeader.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
      : null;
    return matches ? matches[1].replace(/['"]/g, '') : 'file'; // Si no se puede obtener el nombre, se devuelve 'file' por defecto
  }

  saveFile(blob: Blob, filename: string) {
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    filename = filename.trim();
    link.download = filename;
    link.click();
    window.URL.revokeObjectURL(link.href); // Liberar el objeto URL para evitar fugas de memoria
  }

  downloadExcel(
    url: string,
    params: any,
    token: string,
    fileType: string
  ): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: `Token ${token}`,
    });
    return this.http
      .get(url, {
        params: params,
        headers: headers,
        observe: 'response',
        responseType: 'blob' as 'json',
      })
      .pipe(
        map((response: any) => {
          if (!response.body) {
            throw new Error('Empty response body');
          }
          const blob = new Blob([response.body], { type: fileType });
          const filename = this.getFilenameFromResponse(response);
          return { blob, filename };
        }),
        catchError((error) => {
          this.snack.openSnackBar(
            error?.status >= 500 ? 'Ups... Algo ha fallado.' : error?.message
          );
          return error;
        })
        // }
      );
  }
}
